import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(({ spacing }) =>
  createStyles({
    actionBar: {
      padding: '0 .8rem',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      '& h1': {
        fontWeight: 400,
        width: '20%',
        maxWidth: '18rem',
        minWidth: 'fit-content',
        marginRight: spacing(1),
      },
    },
    button: {
      width: '14.9rem',
      height: '4.8rem',
      margin: spacing(0, 0, 0, 2),
    },
  }),
)
